import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const { login } = useAuth();
    const navigate = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();

        try {
            setError('');
            setLoading(true);
            await login(email, password);
            navigate('/dashboard');
        } catch (err) {
            setError('שגיאה בהתחברות: ' + err.message);
        }
        setLoading(false);
    }

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={styles.title}>♠️♥️ התחברות - פוקר ♦️♣️</h2>
                {error && <div style={styles.error}>{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>אימייל</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            style={styles.input}
                            onFocus={(e) => e.target.style.borderColor = '#ffd966'}
                            onBlur={(e) => e.target.style.borderColor = '#c0c0c0'}
                        />
                    </div>

                    <div style={styles.formGroup}>
                        <label style={styles.label}>סיסמה</label>
                        <div style={styles.passwordWrapper}>
                            <input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                style={styles.input}
                                onFocus={(e) => e.target.style.borderColor = '#ffd700'}
                                onBlur={(e) => e.target.style.borderColor = 'rgba(218, 165, 32, 0.3)'}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                style={styles.toggleButton}
                                aria-label={showPassword ? "הסתר סיסמה" : "הצג סיסמה"}
                                onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                            >
                                {showPassword ? "🙈" : "👁️"}
                            </button>
                        </div>
                    </div>

                    <div style={styles.forgotPassword}>
                        <Link
                            to="/forgot-password"
                            style={styles.forgotLink}
                            onMouseEnter={(e) => e.target.style.color = '#009010'}
                            onMouseLeave={(e) => e.target.style.color = '#007008'}
                        >
                            שכחת סיסמה?
                        </Link>
                    </div>

                    <button
                        disabled={loading}
                        type="submit"
                        style={{
                            ...styles.button,
                            opacity: loading ? 0.7 : 1,
                            cursor: loading ? 'not-allowed' : 'pointer',
                        }}
                        onMouseEnter={(e) => {
                            if (!loading) {
                                e.target.style.transform = 'translateY(-3px) scale(1.02)';
                                e.target.style.boxShadow = '0 8px 25px rgba(255, 217, 102, 0.6), inset 0 0 0 2px #ffffff, inset 0 0 0 4px #ffd966';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (!loading) {
                                e.target.style.transform = 'translateY(0) scale(1)';
                                e.target.style.boxShadow = '0 6px 20px rgba(255, 217, 102, 0.4), inset 0 0 0 2px #ffffff, inset 0 0 0 4px #ffd966';
                            }
                        }}
                    >
                        {loading ? '🎰 מתחבר...' : '🎰 התחבר'}
                    </button>
                </form>

                <div style={styles.footer}>
                    אין לך חשבון? <Link to="/signup">הירשם</Link>
                </div>
            </div>
        </div>
    );
}

const styles = {
    container: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1a1a1a 0%, #000000 50%, #1a1a1a 100%)',
        direction: 'rtl',
        padding: '15px',
    },
    card: {
        backgroundColor: '#ffffff',
        padding: '40px 35px',
        borderRadius: '15px',
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.8), inset 0 0 0 8px #ffffff, inset 0 0 0 12px #ffd966',
        width: '100%',
        maxWidth: '450px',
        border: '3px solid #000000',
        position: 'relative',
        overflow: 'hidden',
        background: 'linear-gradient(145deg, #ffffff 0%, #f5f5f5 100%)',
    },
    title: {
        textAlign: 'center',
        marginBottom: '30px',
        color: '#000000',
        fontSize: 'clamp(22px, 5vw, 28px)',
        fontWeight: 'bold',
        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.1)',
        letterSpacing: '0.5px',
        lineHeight: '1.3',
    },
    error: {
        backgroundColor: '#ffe5e5',
        color: '#cc0000',
        padding: '12px',
        borderRadius: '8px',
        marginBottom: '20px',
        textAlign: 'center',
        border: '2px solid #cc0000',
        fontSize: '14px',
    },
    formGroup: {
        marginBottom: '20px',
    },
    label: {
        display: 'block',
        marginBottom: '8px',
        fontWeight: '600',
        color: '#000000',
        fontSize: '15px',
    },
    input: {
        width: '100%',
        padding: '14px 16px',
        border: '2px solid #c0c0c0',
        borderRadius: '8px',
        fontSize: '16px',
        boxSizing: 'border-box',
        backgroundColor: '#ffffff',
        color: '#000000',
        transition: 'all 0.3s ease',
        outline: 'none',
    },
    passwordWrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    },
    toggleButton: {
        position: 'absolute',
        left: '12px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        fontSize: '22px',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'transform 0.2s ease',
        zIndex: 10,
    },
    forgotPassword: {
        textAlign: 'left',
        marginBottom: '25px',
        marginTop: '-5px',
    },
    forgotLink: {
        color: '#007008',
        fontSize: '13px',
        textDecoration: 'none',
        fontWeight: '500',
        transition: 'color 0.3s ease',
    },
    button: {
        width: '100%',
        padding: '18px',
        background: 'radial-gradient(circle at 30% 30%, #ffd966, #d4a843 40%, #ffd966 60%, #d4a843)',
        color: '#000000',
        border: '4px solid #000000',
        borderRadius: '50px',
        fontSize: '17px',
        fontWeight: 'bold',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 6px 20px rgba(255, 217, 102, 0.4), inset 0 0 0 2px #ffffff, inset 0 0 0 4px #ffd966',
        textTransform: 'uppercase',
        letterSpacing: '1.5px',
        position: 'relative',
    },
    footer: {
        marginTop: '25px',
        textAlign: 'center',
        color: '#333333',
        fontSize: '15px',
    },
};
